import styled, { css } from "styled-components";
import { breakpoints } from "./size";

export const HomeSearch = styled.div`
  border-radius: 18px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.cardBg};
  width: min(560px, 94%);
  height: auto;

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  margin: auto;
  padding: 8px 0 18px;
  animation: card-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;

  @keyframes card-in {
    from {
      opacity: 0;
      transform: translateY(14px) scale(0.99);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 92%;
    height: auto;
    margin: 20px auto;
    border-radius: 14px;
    padding-top: 4px;
  }
`;

export const WrapSearch = styled.div`
  width: min(500px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const HomeSearchContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 18px;

  @media only screen and (${breakpoints.mobile}) {
    padding: 18px 0 10px;
  }

  .hero-title {
    width: min(500px, 100%);
    margin-bottom: 10px;
    text-align: left;
  }

  h2 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold", "SatoshiRegular", sans-serif;
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    line-height: 1.08;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    padding: 0;
    margin: 0;

    .line {
      display: block;
      font-family: inherit;
    }

    .line.accent {
      color: ${(props) => props.theme.green};
    }

    .line.normal {
      color: ${(props) => props.theme.white};
      margin-top: 2px;
    }

    @media only screen and (${breakpoints.mobile}) {
      font-size: 23px;
      line-height: 1.08;
    }
  }

  .hero-subtitle {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiRegular";
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    line-height: 18px;
    margin-top: 8px;
    margin-bottom: 0;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 12px;
      line-height: 16px;
    }
  }

  h3 {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiBold";
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 1;
  }

  p {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiRegular";
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 20px;
    margin-bottom: 16px;

    @media only screen and (${breakpoints.mobile}) {
      width: 100%;
    }
  }
`;

export const ToggleSearch = styled.div`
  border-radius: 12px;
  background: ${(props) => props.theme.cardBgAlt};
  border: 0.5px solid ${(props) => props.theme.borderColor};
  width: min(500px, 100%);
  padding: 4px;
  gap: 3px;
  display: flex;
  position: relative;
  overflow: hidden;

  @media only screen and (${breakpoints.mobile}) {
    width: 90%;
  }

  &.disable {
    opacity: 0.4;
  }

  .tab-slider {
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 4px;
    width: calc((100% - 14px) / 3);
    border-radius: 8px;
    background: ${(props) => props.theme.green};
    transition: transform 0.26s cubic-bezier(0.34, 1.56, 0.64, 1);
    z-index: 0;
    pointer-events: none;
  }

  .tab-slider[data-active="0"] {
    transform: translateX(0);
  }

  .tab-slider[data-active="1"] {
    transform: translateX(calc(100% + 3px));
  }

  .tab-slider[data-active="2"] {
    transform: translateX(calc(200% + 6px));
  }
`;

const searchTabStyles = css`
  border-radius: 8px;
  flex: 1;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  cursor: pointer;
  user-select: none;

  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiRegular";
  font-size: 14px;
  font-weight: 400;
  transition: color 0.2s ease;

  @media only screen and (${breakpoints.mobile}) {
    font-size: 13px;
  }

  &.active {
    color: ${(props) => props.theme.textOnAccent};
    font-family: "SatoshiBold";
    font-weight: 700;
  }

  &:not(.active):hover {
    color: ${(props) => props.theme.white};
  }
`;

export const TeamsSearch = styled.div`
  ${searchTabStyles}
`;

export const PlayersSearch = styled.div`
  ${searchTabStyles}
`;

export const CompetitionsSearch = styled.div`
  ${searchTabStyles}
`;

export const SearchForm = styled.div`
  width: min(500px, 100%);
  border-radius: 12px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.inputBg};
  margin-top: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;

  &:focus-within {
    border-color: ${(props) => props.theme.accentBorder};
    background: ${(props) => props.theme.accentBg};
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 90%;
  }
`;

export const SearchResult = styled.div`
  background: ${(props) => props.theme.cardBgAlt};
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 12px;
  width: min(538px, 100%);
  margin-top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media only screen and (${breakpoints.mobile}) {
    width: 90%;
  }

  .loadMoreTeams {
    width: calc(100% - 20px);
    margin: 10px;
    padding: 10px;
    background: ${(props) => props.theme.accentBg};
    border: 0.5px solid ${(props) => props.theme.accentBorder};
    border-radius: 10px;
    color: ${(props) => props.theme.green};
    font-family: "SatoshiBold";
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${(props) => props.theme.accentBgStrong};
      transform: translateY(-1px);
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 2px;

    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    background: transparent;
    padding: 8px;
    flex: 1;
    min-height: 0;

    @media only screen and (${breakpoints.mobile}) {
      max-height: 220px;
    }

    .result-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 9px 10px;
      border-radius: 10px;
      border: 0.5px solid transparent;
      cursor: pointer;
      position: relative;
      animation: item-in 0.38s cubic-bezier(0.16, 1, 0.3, 1) both;
      transition: all 0.2s ease;
    }

    .result-item:nth-child(1) { animation-delay: 0.04s; }
    .result-item:nth-child(2) { animation-delay: 0.08s; }
    .result-item:nth-child(3) { animation-delay: 0.12s; }
    .result-item:nth-child(4) { animation-delay: 0.16s; }
    .result-item:nth-child(5) { animation-delay: 0.2s; }
    .result-item:nth-child(6) { animation-delay: 0.24s; }

    @keyframes item-in {
      from {
        opacity: 0;
        transform: translateX(-8px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .result-item::after {
      content: "›";
      color: ${(props) => props.theme.green};
      font-size: 18px;
      line-height: 1;
      opacity: 0;
      transform: translateX(-5px);
      transition: all 0.2s ease;
      margin-left: auto;
    }

    .result-item:hover {
      background: ${(props) => props.theme.accentBg};
      border-color: ${(props) => props.theme.accentBorder};
      transform: translateX(3px);
    }

    .result-item:hover::after {
      opacity: 1;
      transform: translateX(0);
    }

    .result-item a {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      text-decoration: none;
      min-width: 0;
    }

    .result-item h5 {
      color: ${(props) => props.theme.white};
      font-family: "SatoshiMedium";
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .result-item img {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      object-fit: contain;
      background: ${(props) => props.theme.accentBg};
      border: 0.5px solid ${(props) => props.theme.accentBorder};
      padding: 4px;
      flex-shrink: 0;
    }

    &.competition-results {
      max-height: none;
      padding: 8px 8px 12px;
    }

    .competition-item {
      display: block;
      cursor: default;
      padding: 0;
    }

    .competition-item::after {
      content: none;
    }

    .competition-group {
      padding: 10px 10px 8px;
      border-radius: 10px;
      transition: background 0.15s ease;
      animation: item-in 0.38s cubic-bezier(0.16, 1, 0.3, 1) both;
    }

    .competition-group:hover {
      background: ${(props) => props.theme.accentBg};
    }

    .competition-item.disabled {
      opacity: 0.7;
    }

    .competition-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 6px;
      cursor: pointer;
      width: 100%;
      border: none;
      background: transparent;
      padding: 0;
      text-align: left;
      color: inherit;
    }

    .competition-header:disabled {
      cursor: not-allowed;
    }

    .competition-logo {
      width: 30px;
      height: 30px;
      border-radius: 7px;
      background: ${(props) => props.theme.accentBg};
      border: 0.5px solid ${(props) => props.theme.accentBorder};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
    }

    .competition-logo img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      border-radius: 8px;
      padding: 0;
      border: none;
      background: transparent;
    }

    .competition-info {
      flex: 1;
      min-width: 0;
    }

    .competition-country {
      font-family: "SatoshiRegular";
      font-size: 10px;
      color: ${(props) => props.theme.blueish2};
      text-transform: uppercase;
      letter-spacing: 1.4px;
      margin-bottom: 2px;
      line-height: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .competition-name {
      font-family: "SatoshiBold";
      font-size: 24px;
      font-weight: 700;
      color: ${(props) => props.theme.white};
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .seasons-row {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      padding-left: 40px;
      padding-bottom: 8px;
    }

    .season-pill {
      background: ${(props) => props.theme.cardBg};
      border: 0.5px solid ${(props) => props.theme.borderColor};
      color: ${(props) => props.theme.blueish2};
      border-radius: 6px;
      padding: 4px 12px;
      font-size: 11px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.18s ease;
      white-space: nowrap;
      font-family: "SatoshiRegular";
      line-height: 14px;
    }

    .season-pill:hover {
      border-color: ${(props) => props.theme.accentBorder};
      color: ${(props) => props.theme.green};
      background: ${(props) => props.theme.accentBg};
    }

    .season-pill:disabled {
      cursor: not-allowed;
      opacity: 0.65;
    }

    .season-pill.current {
      border-color: ${(props) => props.theme.green};
      color: ${(props) => props.theme.textOnAccent};
      background: ${(props) => props.theme.green};
      font-weight: 700;
    }

    .divider {
      height: 0.5px;
      background: ${(props) => props.theme.borderColor};
      margin: 4px 10px 10px;
    }
  }
`;

export const SearchContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 9px 10px;
  gap: 8px;

  @media only screen and (${breakpoints.mobile}) {
    padding: 8px 9px;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-width: 0;

  .search-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.7;
    transition: opacity 0.2s ease;
  }

  .search-icon.loading {
    opacity: 1;
  }

  .search-icon img {
    width: 16px;
    height: 16px;
  }

  &:focus-within .search-icon {
    opacity: 1;
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const SearchInput = styled.div`
  position: relative;
  width: 100%;

  input {
    width: 100%;
    min-height: 32px;
    padding-right: 68px;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    background: transparent;
    border: none;
    outline: none;

    &::placeholder {
      color: ${(props) => props.theme.textPlaceholder};
      font-family: "SatoshiRegular";
    }
  }

  .shortcut-badge {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 4px;
  }

  kbd {
    font-family: "SatoshiBold";
    font-size: 10px;
    line-height: 1;
    color: ${(props) => props.theme.blueish2};
    border: 0.5px solid ${(props) => props.theme.borderColor};
    border-radius: 4px;
    padding: 2px 5px;
    background: ${(props) => props.theme.cardBgAlt};
  }

  .clear-btn {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    background: ${(props) => props.theme.cardBgAlt};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.18s ease;

    &:hover {
      background: rgba(242, 10, 70, 0.15);
    }

    img {
      width: 10px;
      height: 10px;
    }

    @media only screen and (${breakpoints.mobile}) {
      right: 3px;
    }
  }
`;

export const SearchByFlag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border-left: 0.5px solid ${(props) => props.theme.borderColor};
  padding-left: 10px;
  flex-shrink: 0;

  @media only screen and (${breakpoints.mobile}) {
    border-left: none;
    border-top: 0.5px solid ${(props) => props.theme.borderColor};
    padding-left: 0;
    padding-top: 8px;
    width: 100%;
    justify-content: space-between;
  }

  h5 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold";
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
    line-height: 14px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 24px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .sliderHome {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.blueish3};
    transition: 0.25s;
  }

  .sliderHome:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    transition: 0.25s;
  }

  input:checked + .sliderHome {
    background-color: ${(props) => props.theme.green};
  }

  input:checked + .sliderHome:before {
    transform: translateX(18px);
  }

  .sliderHome.round {
    border-radius: 34px;
  }

  .sliderHome.round:before {
    border-radius: 50%;
  }
`;

export const TeamTypeToggle = styled.div`
  width: fit-content;
  max-width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 2px;
  margin-top: 0;
  padding: 3px;
  border-radius: 20px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.cardBgAlt};

  @media only screen and (${breakpoints.mobile}) {
    width: fit-content;
  }
`;

export const TeamTypeOption = styled.button`
  border: 0.5px solid transparent;
  background: transparent;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiRegular";
  font-size: 12px;
  line-height: 16px;
  border-radius: 14px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);

  &:hover {
    color: ${(props) => props.theme.white};
  }

  &.active {
    border-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.textOnAccent};
    background: ${(props) => props.theme.green};
    font-family: "SatoshiBold";
  }
`;

export const ToggleSlot = styled.div`
  width: min(500px, 100%);
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;

  .spacer {
    width: 1px;
    height: 32px;
    opacity: 0;
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 90%;
    min-height: 40px;
  }
`;

export const ResultsFrame = styled.div`
  width: min(500px, 100%);
  height: 300px;
  margin-top: 10px;

  &.flag-mode {
    height: 340px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 90%;
    height: 255px;

    &.flag-mode {
      height: 300px;
    }
  }
`;

export const FullAreaWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;
  width: 100%;
  height: auto;

  button {
    margin-top: 8px;
  }
`;

export const Area = styled.div`
  height: auto;
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-bottom: 6px;

  button {
    border-radius: 7px;
    border: none;
    background-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.textOnAccent};
    font-family: "SpaceGrotesk";
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 20px;
    text-transform: uppercase;
    width: auto;
    min-width: 110px;
    cursor: pointer;
    padding: 6px 10px;

    @media only screen and (${breakpoints.mobile}) {
      min-width: 96px;
    }
  }
`;

export const FagsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px 14px;
  margin-top: 10px;
  text-align: center;
  padding: 0 10px;
  overflow: visible;

  &.flagWrapFull {
    justify-content: flex-start;
    overflow: visible;
  }

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
    margin-top: 8px;
  }
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  padding: 0 10px 6px;
  width: 100%;
  overflow: visible;
`;

export const ChooseGrid = styled.div`
  margin: 6px 0 2px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: end;
  width: min(500px, 100%);

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }

  span {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;

    img {
      width: 20px;
      height: 20px;
    }

    &:hover {
      color: ${(props) => props.theme.green};
      text-decoration: underline;
    }
  }
`;

export const Flag = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  width: 78px;

  img {
    width: 58px;
    height: 40px;
    object-fit: contain;
  }

  .react-tooltip {
    background: #cfdae6;
    opacity: 1;
    color: rgba(4, 8, 2, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;
  }

  h3 {
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;
    max-width: 78px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const FlagList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  width: 100%;

  img {
    width: 54px;
    height: 38px;
    object-fit: contain;
  }

  h3 {
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    text-align: left;
    line-height: 20px;
  }
`;

export const HistoryList = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  background: ${(props) => props.theme.cardBgAlt};
  border: 0.5px solid ${(props) => props.theme.borderColor};
  border-radius: 12px;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-self: stretch;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
    max-width: 100%;
    padding: 8px;
  }

  h3 {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiBold";
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: left;
    line-height: 1;
  }

  .history-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 2px;
    flex: 1;
    min-height: 0;

    @keyframes item-in {
      from {
        opacity: 0;
        transform: translateX(-8px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 9px 10px;
      border-radius: 10px;
      border: 0.5px solid transparent;
      position: relative;
      animation: item-in 0.38s cubic-bezier(0.16, 1, 0.3, 1) both;
      transition: all 0.2s ease;

      &:nth-child(1) { animation-delay: 0.04s; }
      &:nth-child(2) { animation-delay: 0.08s; }
      &:nth-child(3) { animation-delay: 0.12s; }
      &:nth-child(4) { animation-delay: 0.16s; }
      &:nth-child(5) { animation-delay: 0.2s; }
      &:nth-child(6) { animation-delay: 0.24s; }

      &::after {
        content: "›";
        color: ${(props) => props.theme.green};
        font-size: 18px;
        line-height: 1;
        opacity: 0;
        transform: translateX(-5px);
        transition: all 0.2s ease;
        margin-left: auto;
      }

      &:hover {
        background: ${(props) => props.theme.accentBg};
        border-color: ${(props) => props.theme.accentBorder};
        transform: translateX(3px);
      }

      &:hover::after {
        opacity: 1;
        transform: translateX(0);
      }

      h5 {
        color: ${(props) => props.theme.white};
        font-family: "SatoshiMedium";
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }

      img {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        object-fit: contain;
        background: ${(props) => props.theme.accentBg};
        border: 0.5px solid ${(props) => props.theme.accentBorder};
        padding: 4px;
        flex-shrink: 0;
      }
    }
  }
`;

export const HistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding: 0 2px;

  img {
    width: 17px;
    height: 17px;
    opacity: 0.7;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }
  }
`;
